import * as React from "react";
import classnames from "classnames";
/* empty css                 */
const CardActions = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: classnames("card-actions", className), ...rest }, children);
export {
  CardActions as default
};
//# sourceMappingURL=CardActions.js.map
